// Transform the date format to ISO 8601 before parsing
// From: "2025-07-30 20:58:40.302707 +0000 UTC"
// To: "2025-07-30T20:58:40.302707Z"
export const transformToISO = (dateStr: string) => {
    if (!dateStr) return dateStr;

    // Replace space with T and remove timezone info, add Z for UTC
    return dateStr
        .replace(' ', 'T') // Replace first space with T
        .replace(/ \+0000 UTC$/, 'Z') // Replace " +0000 UTC" with "Z"
        .replace(/ UTC$/, 'Z'); // Fallback: replace " UTC" with "Z"
};
